export enum ProfileBound {
    Upper,
    Lower
}

export enum VehicleAxle {
    None,
    Total,
    Axle1,
    Axle2,
    Axle3,
    Axle4
}

export interface IAxleWeightOutOfBoundsHistory {
    Id: number;
    VehicleId: number;
    DriverId?: number;
    StartTime: Date;
    EndTime?: Date;
    StartPlotId: number;
    EndPlotId?: number;
    AxleWeightProfileId?: number;
    VehicleAxle: VehicleAxle;
    Bound: ProfileBound;
    AxleWeightExtreme: number;
}
